import React from 'react'
// eslint-disable-next-line no-unused-vars
import { TKelmanDraggableInjury } from './KelmanDraggable-types'

const KelmanDraggableInjury: React.FC<TKelmanDraggableInjury> = ({
  eyeImage,
  eyeContainer,
  children
}) => {
  const Container: React.CSSProperties = {
    height: '200px',
    width: '200px',
    position: 'relative',
    overflow: 'hidden',
    padding: '0'
  }

  return (
    <div>
      <div style={eyeContainer || Container}>
        <img
          src={eyeImage}
          alt='Eye image'
          style={{ width: '100%', position: 'absolute' }}
        />
        {children}
      </div>
    </div>
  )
}

export default KelmanDraggableInjury
